import React from 'react';
import CustomWarningAlert from './CustomWarningAlert';
import { useUnsavedChanges } from '../../hooks/useUnsavedChanges';

interface UnsavedChangesProviderProps {
  hasUnsavedChanges: boolean;
  children: React.ReactNode;
  message?: string;
  title?: string;
}

const UnsavedChangesProvider: React.FC<UnsavedChangesProviderProps> = ({
  hasUnsavedChanges,
  children,
  message,
  title
}) => {
  const {
    showWarning,
    handleConfirmLeave,
    handleCancelLeave
  } = useUnsavedChanges({
    hasUnsavedChanges,
    message,
    title
  });

  return (
    <>
      {children}
      <CustomWarningAlert
        isOpen={showWarning}
        onClose={handleCancelLeave}
        onConfirm={handleConfirmLeave}
        title={title}
        message={message}
        confirmText="Leave Page"
        cancelText="Stay on Page"
      />
    </>
  );
};

export default UnsavedChangesProvider;
